<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error': showError}">
        <div class="info">{{ 'global.infoRequired' | translate}}</div>
        <div [ngClass]="this.isSmallScreen ? 'entry-3-modal': 'entry-single'">
            <label>{{'configurador-consumos.configurador.descripcion' | translate}} *</label>
            <input type="text" formControlName="descripcion">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-3-modal': 'entry-4-modal'">
            <label>{{'configurador-consumos.configurador.etiquetador' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="etiquetadores" [selectedItem]="newEditForm.get('etiquetador')" [disabled]="disabledEtiquetadores" [placeHolder]="false"></app-filterable-list>
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-3-modal': 'entry-4-modal'">
            <label>{{'global.almacen' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="almacenes" [selectedItem]="newEditForm.get('almacen')" [disabled]="disabledAlmacenes" [placeHolder]="false"></app-filterable-list>
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-3-modal': 'entry-4-modal'">
            <label>{{'configurador-consumos.configurador.confeccion' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="confecciones" [selectedItem]="newEditForm.get('confeccion')" [disabled]="disabledConfecciones" [placeHolder]="false"></app-filterable-list>
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-3-modal': 'entry-4-modal'">
            <label>{{'configurador-consumos.configurador.denominacion' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="denominaciones" [selectedItem]="newEditForm.get('denominacion')" [disabled]="disabledDenominaciones" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-3-modal">
            <label>{{'configurador-consumos.configurador.designacion' | translate}} *</label>
            <app-filterable-table [columns]="columns" [properties]="properties" [itemsList]="designaciones" [selectedItem]="newEditForm.get('designacion')" [disabled]="disabledDesignaciones"></app-filterable-table>
        </div>
        <div class="entry-3-modal">
            <label>{{'configurador-consumos.configurador.destino' | translate}}</label>
            <app-filterable-list class="shorter-list" [itemsList]="destinos" [selectedItem]="newEditForm.get('destino')" [disabled]="disabledDestinos" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-3-modal">
            <label>{{'configurador-consumos.configurador.marca' | translate}}</label>
            <app-filterable-list class="shorter-list" [itemsList]="marcas" [selectedItem]="newEditForm.get('marca')" [disabled]="disabledMarcas" [placeHolder]="false"></app-filterable-list>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button *ngIf="!configuradorConsumoId" class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="configuradorConsumoId ? close() : save()">{{configuradorConsumoId ? ('global.cerrar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event">
</app-toast>